function hasHeadlessChromeInSecChUa(): boolean {
  if (!window.navigator?.userAgentData?.brands) {
    return false;
  }

  return window.navigator.userAgentData.brands.some(
    (brand) => brand.brand === "HeadlessChrome",
  );
}

export function isE2e(): boolean {
  if (typeof window === "undefined") {
    return false;
  }

  const hasHeadlessChromeSecChUa = hasHeadlessChromeInSecChUa();

  return hasHeadlessChromeSecChUa;
}
